'use strict'

const web3EthAbi = require('web3-eth-abi')
const { default: Big } = require('big.js')
const getMerkleProofFile = (
  rewardsDistributor,
  { proofsFilePath = 'https://ipfs.io/ipfs' }
) =>
  rewardsDistributor.methods
    .proofsFileHash()
    .call()
    .then(proofsFilehash => fetch(`${proofsFilePath}/${proofsFilehash}`))
    .then(res => res.json())

function decodeLeverageSwapPayload(encodedPayload) {
  const decodedPayload = web3EthAbi.decodeParameters(
    ['uint8', 'bytes'],
    encodedPayload
  )
  return web3EthAbi.decodeParameters(
    [
      'address',
      'address',
      'uint256',
      'uint256',
      'address',
      'uint256',
      'uint256'
    ],
    decodedPayload[1]
  )
}

const decodeSgSwapEvents = function (payload) {
  const payloadWithStargateArgs = `0x${payload
    .replace('0x', '')
    .slice(104, payload.length - 104)}`
  const decodedPayloadWithStargateArgs = web3EthAbi.decodeParameters(
    [
      'uint8',
      'uint256',
      'uint256',
      'uint256',
      {
        CreditObj: {
          credits: 'uint256',
          idealBalance: 'uint256'
        }
      },
      {
        SwapObj: {
          amount: 'uint256',
          eqFee: 'uint256',
          eqReward: 'uint256',
          lkbRemove: 'uint256',
          lpFee: 'uint256',
          protocolFee: 'uint256'
        }
      },
      'bytes',
      'bytes'
    ],
    payloadWithStargateArgs
  )

  return {
    payload: `0x${decodedPayloadWithStargateArgs[7]
      .replace('0x', '')
      .slice(80, decodedPayloadWithStargateArgs[7].length - 80)}`
  }
}

const amountMinFromSlippage = (amount, slippage) =>
  Big(amount)
    .times(Big(1).minus(Big(slippage).div(100)))
    .round(0, Big.roundDown)
    .toFixed()

module.exports = {
  amountMinFromSlippage,
  decodeLeverageSwapPayload,
  decodeSgSwapEvents,
  getMerkleProofFile
}
